import { OnSuccessCallback, useCustomMutation } from './index';

import { QueryError, QueryKeys } from '../queries';

import Config from '../../config';
import { METHODS } from '../constants';
import { Country } from '../../administration/clientAdministrationPage/types';

export type CountryMutationVariable = Omit<Country, 'countryDescription'>;

export const useCreateCountry = (onSuccess?: OnSuccessCallback<Response, CountryMutationVariable>) =>
  useCustomMutation<Response, QueryError, CountryMutationVariable>({
    handleData: body => ({
      url: Config.endpoints.CREATE_COUNTRY,
      method: METHODS.POST,
      body,
    }),
    invalidateKey: query => [QueryKeys.countries.CountriesList].includes(query.queryKey[0] as string),
    errorMessage: 'Creating country failed',
    successMessage: 'Country created successfully',
    onSuccess,
  });

export const useUpdateCountry = (onSuccess?: OnSuccessCallback<Response, CountryMutationVariable>) =>
  useCustomMutation<Response, QueryError, CountryMutationVariable>({
    handleData: body => ({
      url: Config.endpoints.UPDATE_COUNTRY,
      method: METHODS.PUT,
      body,
    }),
    invalidateKey: query => [QueryKeys.countries.CountriesList].includes(query.queryKey[0] as string),
    errorMessage: 'Updating country failed',
    successMessage: 'Country updated successfully',
    onSuccess,
  });

export const useDeleteCountry = (onSuccess?: OnSuccessCallback<Response, Pick<CountryMutationVariable, 'countryCode'>>) =>
  useCustomMutation<Response, QueryError, Pick<CountryMutationVariable, 'countryCode'>>({
    handleData: ({ countryCode }) => ({
      url: Config.endpoints.DELETE_COUNTRY,
      method: METHODS.DELETE,
      body: { countryCode },
    }),
    invalidateKey: query => [QueryKeys.countries.CountriesList].includes(query.queryKey[0] as string),
    errorMessage: 'Removing country failed',
    successMessage: 'Country removed successfully',
    onSuccess,
  });
